<script setup lang="ts">
const props = defineProps<{
  data: any[];
  loadingNumber?: number | null;
}>();

const count = computed(() => props.data.length);
const numPerPage = ref(10);
const page = ref(1);

const startIndex = computed(() => (page.value - 1) * numPerPage.value);
const endIndex = computed(() =>
  Math.min(page.value * numPerPage.value, count.value),
);
const filteredData = computed(() =>
  props.data.slice(startIndex.value, endIndex.value),
);

function goToPage(p: number) {
  page.value = p;
}

defineExpose({
  goToPage,
});
</script>

<template>
  <slot :data="filteredData" />
  <div class="px-7 pb-5">
    <BasePagination
      v-model:num-per-page="numPerPage"
      class="mt-3"
      v-model:page="page"
      :count="count"
      :loading-number="loadingNumber"
    />
  </div>
</template>

<style scoped lang="postcss"></style>
